import {
  chainDynamicValue,
  DynamicValue,
  useComponentState,
} from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import {
  Accordion,
  AccordionCollapse,
  AccordionToggle,
  Card,
  Col,
  Form,
} from "react-bootstrap";
import FormJoinUsPrice from "src/components/FormJoinUsPrice";
import Heading from "src/components/Heading";
import MqGteTablet from "src/components/MqGteTablet";
import Paragraph from "src/components/Paragraph";
import Text from "src/components/Text";
import Translate from "src/components/Translate";
import gutter from "src/functions/gutter";
import onChangeToValue from "src/functions/onChangeToValue";
import { sFormAccordion } from "src/styles/sFormAccordion.module.scss";
import { sFormControl } from "src/styles/sFormControl.module.scss";
import { sFormLabel } from "src/styles/sFormLabel.module.scss";
import { sNote } from "src/styles/sNote.module.scss";
import { DataJoinUsForm } from "src/types/DataJoinUsForm";

type Props = { formData: DynamicValue<DataJoinUsForm> };

function FormJoinUsPrices({ formData }: Props) {
  var toggleAccordion = useComponentState(false);
  return (
    <Accordion
      defaultActiveKey={`1`}
      className={composeClassNames([sFormAccordion, "joinus-prices"])}
    >
      <Card>
        <AccordionToggle eventKey={`0`}>
          <Heading
            type={`h2`}
            title={
              <>
                {`5. `}
                <Translate tKey={`Prices`} />
                <Text size={`md`} width={`regular`}>
                  {`2 `}
                  <Translate tKey={`min.`} />
                </Text>
              </>
            }
          />
        </AccordionToggle>
        <AccordionCollapse eventKey={`0`}>
          <Card.Body>
            <Paragraph style={gutter(`margin`, `top`, `0`)} size={`md`}>
              <Translate
                tKey={`You don't have to state prices if you don't want to. Pricing options help set expectations on both sides correctly.`}
              />
            </Paragraph>
            <Form.Text
              className={sNote}
              style={gutter(`margin`, `bottom`, `md`)}
            >
              <Translate
                tKey={`An example of a price variant is: Subject = Open lesson; Value = 200; Currency = CZK; Time period = 1.5 hours.`}
              />
            </Form.Text>
            <MqGteTablet>
              <Form.Row>
                <Col sm={4} xs={12}>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Subject`} />
                  </Form.Label>
                </Col>
                <Col sm={2} xs={6}>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Price`} />
                  </Form.Label>
                </Col>
                <Col sm={2} xs={6}>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Currency`} />
                  </Form.Label>
                </Col>
                <Col sm={4} xs={12}>
                  <Form.Label className={sFormLabel}>
                    <Translate tKey={`Time interval`} />
                  </Form.Label>
                </Col>
              </Form.Row>
            </MqGteTablet>
            <FormJoinUsPrice
              key={1}
              item={1}
              formDataPriceSubject={chainDynamicValue(
                formData,
                "price-subject-1"
              )}
              formDataPriceValue={chainDynamicValue(formData, "price-value-1")}
              formDataPriceCurrency={chainDynamicValue(
                formData,
                "price-currency-1"
              )}
              formDataPriceInterval={chainDynamicValue(
                formData,
                "price-interval-1"
              )}
            />
            <FormJoinUsPrice
              key={2}
              item={2}
              formDataPriceSubject={chainDynamicValue(
                formData,
                "price-subject-2"
              )}
              formDataPriceValue={chainDynamicValue(formData, "price-value-2")}
              formDataPriceCurrency={chainDynamicValue(
                formData,
                "price-currency-2"
              )}
              formDataPriceInterval={chainDynamicValue(
                formData,
                "price-interval-2"
              )}
            />
            <FormJoinUsPrice
              key={3}
              item={3}
              formDataPriceSubject={chainDynamicValue(
                formData,
                "price-subject-3"
              )}
              formDataPriceValue={chainDynamicValue(formData, "price-value-3")}
              formDataPriceCurrency={chainDynamicValue(
                formData,
                "price-currency-3"
              )}
              formDataPriceInterval={chainDynamicValue(
                formData,
                "price-interval-3"
              )}
            />
            <FormJoinUsPrice
              key={4}
              item={4}
              formDataPriceSubject={chainDynamicValue(
                formData,
                "price-subject-4"
              )}
              formDataPriceValue={chainDynamicValue(formData, "price-value-4")}
              formDataPriceCurrency={chainDynamicValue(
                formData,
                "price-currency-4"
              )}
              formDataPriceInterval={chainDynamicValue(
                formData,
                "price-interval-4"
              )}
            />
            <Form.Group>
              <Form.Label className={sFormLabel}>
                <Text size={`nm`}>
                  <Translate tKey={`Other price variants`} />
                </Text>
              </Form.Label>
              <Form.Control
                className={sFormControl}
                as={`textarea`}
                rows={5}
                name={`price-variants`}
                id={`price-variants`}
                onChange={function (param2) {
                  return chainDynamicValue(formData, "price-variants").change(
                    onChangeToValue(param2)
                  );
                }}
                value={chainDynamicValue(formData, "price-variants").value}
              />
              <Form.Text className={sNote}>
                <Translate
                  tKey={`Pokud máte více cenových variant, tak je můžete uvést do následujícho textového pole. Vždy jednu variantu na řádek. Oddělte je středníky: Předmět; Hodnota; Měna; Časový úsek.`}
                />
              </Form.Text>
            </Form.Group>
          </Card.Body>
        </AccordionCollapse>
      </Card>
    </Accordion>
  );
}

export default FormJoinUsPrices;
